module.exports = __webpack_public_path__ + "entry-150bfe9b/carola-ludewig-photo-62028cde65050610c3e870975425861d.webp";